import type { PaginatedResponse } from '@repo/types/pagination';
import type { ParentChildQuizAttempt } from '@repo/types/parent';
import type { UserPublic } from '@repo/types/users';

import type { GetChildListParams } from './parentService';
import type { ChildrenResourceResult } from './useChildrenResource';

import { ParentKey } from './keys';
import { ParentService } from './parentService';
import { useChildrenResource } from './useChildrenResource';

/**
 * A page of completed quiz attempts per linked child, aggregated.
 *
 * `paramsFor` derives each child's query — children paginate independently, so
 * `page` typically differs per child while the filters are shared.
 */
export function useGetChildrenQuizzes(
  children: UserPublic[],
  paramsFor?: (child: UserPublic) => GetChildListParams,
  enabled = true
): ChildrenResourceResult<PaginatedResponse<ParentChildQuizAttempt>> {
  return useChildrenResource(
    children,
    (child) => [ParentKey.CHILD_QUIZZES, child.id, paramsFor?.(child)],
    (child) => ParentService.getChildQuizzes(child.id, paramsFor?.(child)).then((response) => response.data),
    enabled
  );
}
